import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  socialButton: {
    padding: 0,
    marginRight: 38,
    '&:last-child': {
      marginRight: 0,
    },
    [theme.breakpoints.up('mobile')]: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      marginRight: theme.spacing(4),
    },
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/SocialButtons/useStyles.js